export default {
  EBWC_BIG_WIN: 15,
  EBWC_MEGA_WIN: 30,
}
